import { useMemo } from 'react'

interface SparklineProps {
  data: number[]
  width?: number
  height?: number
  strokeColor?: string
  fillColor?: string
  strokeWidth?: number
  showFill?: boolean
}

export function Sparkline({
  data,
  width = 80,
  height = 32,
  strokeColor = '#40C351',
  fillColor = 'rgba(64,195,81,0.08)',
  strokeWidth = 1.5,
  showFill = true,
}: SparklineProps) {
  const path = useMemo(() => {
    if (!data || data.length < 2) return ''
    const min = Math.min(...data)
    const max = Math.max(...data)
    const range = max - min || 1
    const stepX = width / (data.length - 1)

    const points = data.map((v, i) => {
      const x = i * stepX
      const y = height - ((v - min) / range) * (height - 4) - 2
      return `${x},${y}`
    })

    const line = points.map((p, i) => `${i === 0 ? 'M' : 'L'}${p}`).join(' ')

    if (!showFill) return line

    const bottomY = height
    const fill = `${line} L${width},${bottomY} L0,${bottomY} Z`
    return { line, fill }
  }, [data, width, height, showFill])

  if (!data || data.length < 2) return null

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className="shrink-0"
    >
      {showFill && typeof path === 'object' && (
        <path d={path.fill} fill={fillColor} />
      )}
      <path
        d={typeof path === 'string' ? path : path.line}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
